import {
  Directive,
  ElementRef,
  OnInit,
  Output,
  EventEmitter
} from "@angular/core";
import {} from "googlemaps";

@Directive({
  selector: "[google-places]"
})
export class GooglePlacesDirective implements OnInit {
  private element: HTMLInputElement;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  constructor(private elRef: ElementRef) {
    this.element = elRef.nativeElement;
  }
  ngOnInit() {
    var bangaloreBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(60.1699, 24.9384)
    );
    const autocomplete = new google.maps.places.Autocomplete(this.element, {
      bounds: bangaloreBounds,
      strictBounds: false
    });
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      //Emit the new address object for the updated place
      this.onSelect.emit(this.getFormattedAddress(autocomplete.getPlace()));
    });
  }

  getFormattedAddress(place) {
    //@params: place - Google Autocomplete place object
    //@returns: location_obj - An address object in human readable format
    let location_obj = {};
    location_obj["latitude"] = place.geometry.location.lat();
    location_obj["longitude"] = place.geometry.location.lng();
    location_obj["address"] = place.formatted_address;
    return location_obj;
  }
}
